/* BB cart drawer (PDP). Markup/prices come from Liquid (snippets/bb-cart-drawer.liquid via the section "bb-cart-drawer", Section Rendering API).
   API:  window.bbCartDrawer.sectionIds   -> pass as "sections" to /cart/add.js (and /cart/change.js)
         window.bbCartDrawer.show(addResponse, opener) -> re-render from that response (or fetch it) and slide the drawer in
         window.bbCartDrawer.open(opener) / .close() / .refresh() */
(function () {
  if (window.bbCartDrawer) return;
  var SECTION = 'bb-cart-drawer', IDS = SECTION + ',cart-counter';
  var root, panel, body, opener, busy = false, pendingErr = '';
  /* texts: non-English pages pass them from Liquid (snippets/bb-cart-drawer.liquid, data-bbcd-i18n-*); English fallback here */
  var ERR = 'Something went wrong. Please try again.';
  /* locale root ('/' or '/fr/' ...) so a refresh renders the drawer in the page's language */
  var ROOT_URL = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function setup() {
    var all = document.querySelectorAll('[data-bbcd]');
    if (!all.length) return false;
    root = all[all.length - 1];
    for (var i = 0; i < all.length - 1; i++) if (all[i].parentNode) all[i].parentNode.removeChild(all[i]);   // section re-rendered (theme editor): keep the newest only
    if (root.parentNode !== document.body) document.body.appendChild(root);   // fixed layer straight under <body> (theme fade-in wrappers use transforms)
    panel = root.querySelector('.bbcd__panel'); body = root.querySelector('[data-bbcd-body]');
    if (root.getAttribute('data-bbcd-i18n-error')) ERR = root.getAttribute('data-bbcd-i18n-error');
    return !!(panel && body);
  }

  function parse(html, selector) { var d = new DOMParser().parseFromString(html, 'text/html'); return d.querySelector(selector); }

  /* put the server-rendered pieces in place: drawer content + the header bag counter */
  function apply(sections) {
    if (!sections) return false;
    var done = false;
    if (sections[SECTION]) {
      var frag = parse(sections[SECTION], '[data-bbcd-fragment]');
      if (frag) { body.innerHTML = frag.outerHTML; done = true; showErr(); }
    }
    if (sections['cart-counter']) {
      var cnt = parse(sections['cart-counter'], '#shopify-section-cart-counter'), tgt = document.querySelector('#cart-counter');
      if (cnt && tgt) tgt.innerHTML = cnt.innerHTML;
    }
    return done;
  }

  function showErr() {
    var e = body.querySelector('[data-bbcd-err]');
    if (!e) return;
    e.textContent = pendingErr; e.hidden = !pendingErr; pendingErr = '';
  }

  function refresh() {
    return fetch(ROOT_URL + '?sections=' + IDS + '&_=' + Date.now(), { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(apply);
  }

  function focusables() {
    return Array.prototype.slice.call(panel.querySelectorAll('a[href],button:not([disabled]),[tabindex]:not([tabindex="-1"])')).filter(function (el) { return el.offsetParent !== null || el === document.activeElement; });
  }

  function open(from) {
    if (!root && !setup()) return;
    if (from) opener = from; else if (!opener) opener = document.activeElement;
    root.classList.add('is-open'); root.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('bbcd-lock');
    setTimeout(function () { var x = panel.querySelector('[data-bbcd-close]'); (x || panel).focus({ preventScroll: true }); }, 60);
  }

  function close() {
    if (!root || !root.classList.contains('is-open')) return;
    root.classList.remove('is-open'); root.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('bbcd-lock');
    var o = opener; opener = null;
    if (o && o.focus && document.contains(o)) try { o.focus({ preventScroll: true }); } catch (e) {}
  }

  /* after /cart/add.js: use the sections it returned, else fetch them */
  function show(addResponse, from) {
    if (!root && !setup()) return Promise.resolve();
    var ok = addResponse && addResponse.sections && apply(addResponse.sections);
    return (ok ? Promise.resolve(true) : refresh().catch(function () { return false; })).then(function () { open(from); });
  }

  /* qty / remove: /cart/change.js with the line key */
  function change(key, qty, focusSel) {
    if (busy) return;
    busy = true; root.classList.add('is-busy');
    fetch('/cart/change.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: key, quantity: qty, sections: IDS, sections_url: location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (r) {
        if (r && r.status && !r.sections) { pendingErr = r.description || r.message || ERR; return refresh(); }
        if (!apply(r.sections)) return refresh();
      })
      .catch(function () { pendingErr = ERR; return refresh().catch(function () {}); })
      .then(function () {
        busy = false; root.classList.remove('is-busy'); showErr();
        if (focusSel) { var f = body.querySelector(focusSel); if (f && !f.disabled) f.focus({ preventScroll: true }); else { var x = body.querySelector('[data-bbcd-close]'); if (x) x.focus({ preventScroll: true }); } }
      });
  }

  /* strap suggestions: '+ Add' -> /cart/add.js, then the drawer is re-rendered from the same response (or refreshed) */
  function addUp(btn) {
    if (busy) return;
    busy = true; root.classList.add('is-busy'); btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: parseInt(btn.getAttribute('data-bbcd-add'), 10), quantity: 1 }], sections: IDS, sections_url: location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (r) {
        if (r && r.status && !r.sections) { pendingErr = r.description || r.message || ERR; return refresh(); }
        if (!apply(r.sections)) return refresh();
      })
      .catch(function () { pendingErr = ERR; return refresh().catch(function () {}); })
      .then(function () { busy = false; root.classList.remove('is-busy'); showErr(); });
  }

  document.addEventListener('click', function (e) {
    if (!root) return;
    var ad = e.target.closest('[data-bbcd-add]');
    if (ad && root.contains(ad)) { e.preventDefault(); if (!ad.disabled) addUp(ad); return; }
    if (e.target.closest('[data-bbcd-close]') && root.contains(e.target.closest('[data-bbcd-close]'))) { e.preventDefault(); close(); return; }
    var q = e.target.closest('[data-bbcd-qty]');
    if (q && root.contains(q)) {
      var li = q.closest('.bbcd__li'); if (!li || q.disabled) return;
      var n = parseInt(q.getAttribute('data-bbcd-qty'), 10), key = li.getAttribute('data-key');
      var sel = q.classList.contains('bbcd__rm') ? '' : '.bbcd__li[data-key="' + key.replace(/"/g, '\\"') + '"] .bbcd__qty button:' + (q === q.parentNode.firstElementChild ? 'first-child' : 'last-child');
      e.preventDefault(); change(key, n, sel);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (!root || !root.classList.contains('is-open')) return;
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key === 'Tab') {
      var f = focusables(); if (!f.length) { e.preventDefault(); panel.focus(); return; }
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && (document.activeElement === first || document.activeElement === panel)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      else if (!panel.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
    }
  });

  window.bbCartDrawer = { sectionIds: IDS, show: show, open: open, close: close, refresh: refresh };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup); else setup();
})();
